import { FC } from 'react';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { useSelector } from 'react-redux';
import { makeStaticUrl } from '@doda/common/src/logics/staticUrl';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { createPreBtn } from '@doda/common/src/logics/JobContent/createPreBtn';
import { convertQueryToURI } from '@doda/common/src/logics/JobContent/convertQueryToURI';
import styles from './index.module.scss';

/**
 * HeaderTabのProps
 * @param isJobRankingLinkShow 求人ランキングのリンク表示可否
 */
interface Props {
  isJobRankingLinkShow: boolean;
}

export const HeaderTab: FC<Props> = ({ isJobRankingLinkShow }) => {
  // queryの取得
  const queryParams = useSelector(appQueryParamsSelector);

  const jobSearchListUrl = makeStaticUrl(
    createPreBtn(convertQueryToURI(queryParams)),
    DODA_SITE_URL.jobSearchList
  );

  // 求人ランキングのリンク表示対象外、または市区町村パラメータの場合、求人ランキングリンク生成しない
  const jobRankingUrl = isJobRankingLinkShow
    ? makeStaticUrl(convertQueryToURI(queryParams), DODA_SITE_URL.jobRanking)
    : '';

  return (
    <div className={styles.headerTab}>
      <ul className={styles.headerTab__list}>
        <li className={styles.headerTab__item}>
          <a className="headerTab__item--link" href={jobSearchListUrl}>
            求人一覧
          </a>
        </li>
        <li className={styles.headerTab__item}>
          <span className="headerTab__item--title">求人の傾向</span>
        </li>
        {jobRankingUrl && (
          <li className={styles.headerTab__item}>
            <a className="headerTab__item--link" href={jobRankingUrl}>
              人気求人ランキング
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};
